import React, { Component } from 'react';
import Popup from "reactjs-popup";
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { MAX_AD_TIME } from '../services/ABeCProperties'
import PageVisibility from 'react-page-visibility'
import adService from './service/adService';
import './styles/popup.css';
import TextDecoration from '../utility/TextDecoration';
import { TitleHeading } from '../UIElements/headings/TitleHeading';
import { ButtonStyle } from '../UIElements/Buttons/ButtonStyle';
import { RedirectLink } from '../UIElements/Redirect_link/Redirect_link';

class PopUpAd extends Component {

    constructor(props) {
        super(props);
        this.popupTimer = null;
        this.state = {
            open: true,
            closeButton: false,
            isPaid: false,
            ad: {},
            popupTimeLaps: 30,
        }
        this.popupTimeLaps = 0;
    }

    isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    componentDidMount() {
        this.setState({ open: true }, () => {
                this.showAdvertisement([...this.props.ads])
        })
        this.updateVisibleAds()
        this.props.notifyPopupOpen(true)
    }

    componentWillUnmount = () => {
        this.stopTimer();
        this.props.cleanUp();
    }

    showAdvertisement = (ads) => {
        if (ads.length) {
            const ad = ads.splice(0, 1)[0]
            if (this.props.viewedAds.includes(ad.id + ":popup"))
                this.showAdvertisement(ads)
            else
                if (ad) {
                    this.setState({ ad }, () => {
                        this.startTimer();
                        //window.scrollTo(0, 0);
                    });
                } else
                    this.setState({ open: false });
        } else {
            this.setState({ open: false });
        }
    }

    startTimer = () => {
        if (this.popupTimeLaps) {
            this.stopTimer();
        }
        if (this.state.open && this.state.ad.id && this.popupTimeLaps <= MAX_AD_TIME) {
            this.popupTimer = setInterval(() => {
                this.popupTimeLaps += 1;
                this.setState({ popupTimeLaps: 30 - this.popupTimeLaps })
                if (this.popupTimeLaps > MAX_AD_TIME) {
                    this.setState({ closeButton: true });
                    this.stopTimer();
                    this.updateViews(this.state.ad.id);
                }
            }, 1000);
        }
        if (this.seconds = 1) {
            this.updateAdDisplay(this.state.ad.id)
        }
    }

    stopTimer = () => {
        clearInterval(this.popupTimer);
    }

    updateAdDisplay = (id) => {
        if (id !== undefined && id !== null) {
            const listingData = {
                viewedOnListing: this.props.listingData.viewedOnListing,
                section: this.props.listingData.place,
            }
            adService.updateAdDisplay(id, 'popup', listingData).then(result => {
                this.setState({ section: result })
            })
        }
    }

    updateViews = (id) => {
        if (id !== undefined && id !== null) {
            const listingData = {
                viewedOnListing: this.props.listingData.viewedOnListing,
                viewed: this.props.listingData.isViewed,
                section: this.props.listingData.place,
            }
            adService.updateViews(id, 'popup', listingData).then(result => {
                this.setState({ isPaid: result })
                if (result === true) {
                    this.props.sendViewedAds(id + ":popup");
                }
            })

        }
    }

    closeAdvertisement = () => {
        this.updateVisibleAds()
        // this.props.notifyPopupOpen(false) App.js does the job
        this.popupTimeLaps = 0;
    }

    updateVisibleAds = () => {
        const adName = "popup"
        if (!this.props.visibleAds.includes(adName)) {
            this.props.setVisibleAds([...this.props.visibleAds, adName])
        } else if (this.props.visibleAds.includes(adName)) {
            this.props.setVisibleAds(this.props.visibleAds.filter(e => e !== adName))
        }
    }

    render() {
        const style = {
            position: 'relative',
            background: 'rgb(255 255 255 / 100%)',
            width: '1250px',
            height: '660px',
            margin: 'auto',
            border: 'none', //4px solid #fffaf5',
            padding: '5px',
        }
        const verticleCenter = {
            position: 'absolute',
            inset: '0',
            width: 'auto',
            margin: 'auto',
            marginTop: '0',
        }
        return (
            <PageVisibility
                onChange={(isVisible) => {
                    if (!isVisible)
                        this.stopTimer();
                    else if (this.popupTimeLaps < MAX_AD_TIME)
                        this.startTimer();
                }}>
                <Popup
                    open={this.state.open}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    onClose={this.closeAdvertisement}
                    lockScroll={true}
                    contentStyle={style}
                    overlayStyle={{ background: 'rgba(0,0,0,0.95)' }}
                >
                    <div className="popup_height">
                        <div className="popup_inner_height" key="message">
                            {(this.state.closeButton) ?
                                <div className="form-row">
                                    <div className="col-md-10 text-right">
                                        {!this.state.isPaid ? null :
                                            <TitleHeading>
                                                {this.props.is_login ? 'Congratulations! You got paid for viewing this advertisement. Thanks for viewing!!!'
                                                    : <><Link to='/login/user'><RedirectLink text={'Login'} /></Link> to get paid for watching advertisements</>}
                                            </TitleHeading>}
                                    </div>
                                    <div className="col-md-2 text-right">
                                        <ButtonStyle type="button"
                                            className="btn popup_margin"
                                            handleClick={() => this.setState({ open: false })} >Close</ButtonStyle>
                                    </div>
                                </div>
                                : <TitleHeading>Popup Advertisement: You will see <span className='popup_listing_title'>"{TextDecoration.ellipsize(this.props.listingData.listingTitle, 50)}"</span> in &nbsp;
                                    <RedirectLink >{this.state.popupTimeLaps}</RedirectLink><span>s</span></TitleHeading>}
                        </div>
                        <div style={{
                            position: 'relative',
                            height: '95%',
                            overflowY: 'auto',
                            margin: '0 auto',
                        }} id='adWrapperDiv' key="advertisement"> {console.log(this.state.ad.mediaType)}
                            {(!this.isEmpty(this.state.ad) && this.state.ad.mediaType === 'video')
                                ?
                                <video className={`img-fluid ${this.state.ad.website ? 'cursor_pointer' : ''}`}
                                    onClick={() => adService.redirect(this.state.ad.website)}
                                    style={verticleCenter} autoPlay={true} loop>
                                    <source id="popUpAds-video-ad" src={process.env.REACT_APP_IMAGES_URL + this.state.ad.advertisement} type="video/mp4" onLoad={this.handleImageLoad} />
                                </video>
                                :
                                <img className={`img-fluid ${this.state.ad.website ? 'cursor_pointer' : ''}`} style={verticleCenter} alt="PopUp Ad"
                                    id="popUpAds-ad" src={process.env.REACT_APP_IMAGES_URL + this.state.ad.advertisement}
                                    onClick={() => adService.redirect(this.state.ad.website)}
                                />
                            }
                        </div>
                    </div>
                </Popup>
            </PageVisibility>
        )
    }
}

const mapStateToProps = state => {
    return {
        viewedAds: state.viewedAds,
        is_login: state.is_login,
        visibleAds: state.visibleAds,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        notifyPopupOpen: (isPopupOpen) => dispatch({ type: 'POPUP_OPEN_NOTIFICATION', isPopupOpen: isPopupOpen }),
        sendViewedAds: (viewedAds) => dispatch({ type: 'VIEWED_ADS', viewedAds: viewedAds }),
        setVisibleAds: (visibleAds) => dispatch({ type: 'VISIBLE_ADS', visibleAds: visibleAds }),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PopUpAd));